import { Api } from "../config/request";

export default {
  getConfigChangeLog(queryParams) {
    return Api.get(
      `/feature-config/config-version${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
  updateConfig(payload) {
    return Api.post("/feature-config/upsert", payload);
  },
};
